window.__componentAdapter = {
    components: {},
    runner: null,
    componentsWaiting: 0,
    latestBatch: [],
    render: rerenderComponent,
    setExtraParam: setExtraParam,
    ajaxErrors: [],
    fragments: {}
}

const COMPONENTS = 'components-v1'; // match this with service_worker.js and offline_handler.js

window.onpopstate = response => {
    if (response.state && response.state.st_async) {
        window.location.reload();
    }
};

function __enqueueComponent(component, body, rerender, callback, subcomponents='[]') {
    __componentAdapter.components[component.id] = {
        id: component.id,
        name: component.name,
        children: component.children,
        body: body,
        jsc: !rerender && component.jsc,
        options: component.options,
        rerender: rerender,
        extra_params: component.extra_params,
        subcomponents: JSON.parse('[' + subcomponents + ']')
    };

    if (__componentAdapter.runner) {
        __componentAdapter.runner.execute();
    }
    if (callback) callback();
}

function renderComponents(components, rerender=false, callback=null) {
    var csrfTokenElement = document.querySelector('meta[name="csrf-token"]');
    __initializeComponentAdapter(components);
    components.forEach(function(component) {
        if (component.deferred || !component.controller) {
            __componentAdapter.componentsWaiting -= 1;
            return component.deferred = false;
        }

        let related_fragment = __componentAdapter.fragments[component.hash];
        if (related_fragment && !component.extra_params && related_fragment[3] === true) {
            return __enqueueFragment(related_fragment, component, callback);
        }
        var xhr = __createXhr(component, csrfTokenElement);
        xhr.onload = function() {
            if (xhr.status !== 200) {
                __componentAdapter.componentsWaiting -= 1;
                return __componentAdapter.ajaxErrors.push([xhr.responseText, component]);
            }
            __cacheResponse(component, xhr.responseText);
            let subcomponents = xhr.getResponseHeader('Subcomponent-Javascript');
            __enqueueComponent(component, xhr.responseText, rerender, callback, subcomponents);
        };
        xhr.onerror = function() {
            if (related_fragment && related_fragment[3] == 'prefer_online') {
                return __enqueueFragment(related_fragment, component, callback);
            }
        }
        xhr.send(component.options || {});
    });
}

function __initializeComponentAdapter(components) {
    __componentAdapter.latestBatch = components.map(function(c) { return c.id })
    __componentAdapter.componentsWaiting += components.length;
    __componentAdapter.ajaxErrors = [];
    if (__componentAdapter.runner) {
        __componentAdapter.runner.getLocator().loaded = false;
    }
}

function __cacheResponse(component, response) {
    if (!component.idempotent || component.hash in __componentAdapter.fragments) {
        return
    }
    __componentAdapter.fragments[component.hash] = [
        component.children,
        response,
        component.child_names,
        component.idempotent
    ];
    if (window.caches) {
        window.caches.open(COMPONENTS).then(function(c) {
            c.put('fragments', new Response(JSON.stringify(__componentAdapter.fragments)))
        });
    }
}

function __createXhr(component, csrfTokenElement) {
    var xhr = new XMLHttpRequest();
    var componentRequestQueryString = buildComponentQueryString(
        component.extra_params || {}, document.location.search)
    xhr.open('POST', '/' + component.controller + '_component/' + componentRequestQueryString);
    xhr.setRequestHeader('Content-Type', 'text/plain');
    xhr.setRequestHeader('Component-Id', component.id);
    xhr.setRequestHeader('Component-Hash', component.hash);
    if (csrfTokenElement) {
        xhr.setRequestHeader('X-CSRF-Token', csrfTokenElement.content);
    }
    return xhr;
}

function __enqueueFragment(related_fragment, component, callback) {
    let fragment = related_fragment[1].slice(0); // clone
    for (let i = 0; i < component.children.length; i++) {
        fragment = fragment
            .replace(
                'wrapper_' + related_fragment[0][i] + ' ',
                'wrapper_' + component.children[i] + ' '
            ).replace(
                'data-component-id=' + related_fragment[0][i] + '>',
                'data-component-id=' + component.children[i] + '>'
            );
    }
    __enqueueComponent(component, fragment, false, callback);
}

function rerenderComponent(id, asRerender=true, callback=null) {
    let componentsById = {}
    components.forEach(function(component) {
        componentsById[component.id] = component;
    });

    let componentsToRerender = __getChildren(id, componentsById);
    renderComponents(componentsToRerender, asRerender, callback);
}

function setExtraParam(id, key, value) {
    let component = components.find(c => c.id == id);
    component.extra_params = component.extra_params || {};
    component.extra_params[key] = value;
    if (component.children) {
        component.children.forEach(child => setExtraParam(child, key, value));
    }
}

function __getChildren(id, componentsById) {
    let components = [componentsById[id]];
    (components[0].children || []).forEach(function(child) {
        components = components.concat(__getChildren(child, componentsById));
    });
    return components;
}

function buildComponentQueryString(params, queryString = '') {
    Object.keys(params).forEach( (key) => {
        queryString += (queryString.includes('?')) ? `&${key}=${params[key]}` : `?${key}=${params[key]}`
    })
    return queryString;
}

document.addEventListener('ComponentRendered', (event) => {
    Array.from(document.querySelectorAll('#wrapper_' + event.componentId + ' .react-container'))
            .forEach(function(component) {
        name = component.attributes['id'].value.split('_').splice(1).join('_');
        let reactReady = new Event('ReactReady_' + name);
        reactReady.componentId = event.componentId;
        reactReady.options = event.options;
        for(let index = 0; index < component.attributes.length; index++ ){
            let node = component.attributes[index]
            if (node.name.startsWith('data-param')) {
                reactReady[node.name] = node.value
            }
        }
        document.dispatchEvent(reactReady);
    });
})

if (window.caches) { // Cache fragment hash.
    window.caches.open(COMPONENTS).then(function(c) {
        c.match('fragments').then(function(fragments) {
            if (fragments) {
                fragments.json().then(function(body) {
                    __componentAdapter.fragments = body || {};
                    renderComponents(components);
                });
            } else {
                renderComponents(components);
            }
        });
    });
} else {
    renderComponents(components);
}
